/**
 * Builds fetchye options for the passkey registration API calls.
 *
 * @param {Object} params
 * @param {string} [params.method] - HTTP method (default: 'POST')
 * @param {Object} [params.body] - Request body to be JSON-serialized
 * @param {boolean} [params.defer] - Whether to defer the request (default: true)
 * @param {Object} [params.headers] - Additional headers to merge
 * @returns {Object} fetchye options
 */

/* istanbul ignore next -- browser compat fallback */
const generateUUID = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  /* eslint-disable no-bitwise -- bitwise required for UUID generation */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
  /* eslint-enable no-bitwise */
};

const idempotencyKey = generateUUID();

const buildFetchOptions = ({
  method = 'POST', body = {}, defer = true, headers = {},
} = {}) => ({
  defer,
  method,
  headers: {
    'Content-Type': 'application/json',
    'Idempotency-Key': idempotencyKey,
    ...headers,
  },
  body: JSON.stringify(body),
});

export default buildFetchOptions;
